module.exports = __webpack_public_path__ + "media/images/bookings/childcare/supervisor@3x-add2698ed00191e5af9d2e90d2b0b72e.jpg";